<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import i18n from "../../../../i18n";
import { paymenttermService } from "../../../../services/paymentservice/paymentterm.service";
import { servicehelpers } from "../../../../services/servicehelpers";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Term Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "term template",
      breadCrumb: {},

      term: {},
      roundingRuleDataList: {},
      paymentPeroidTypeDataList: {},
      valueName: '',
      valueNameEn: '',
      valuePeroid: 0,
      valuePeroidType: 0,
      valueRoundingRule: 0,
      valueIsCustomize: 0,
      valueIsForSale: 0,

    };
  },
  mounted() {

    this.loadingRoundingRuleData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      paymenttermService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.term = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };

          this.valueName = this.term.name;
          this.valueNameEn = this.term.name_en;
          this.valuePeroid = this.term.period;
          this.valueRoundingRule = this.term.rounding_rule_id;
          this.valuePeroidType = this.term.payment_period_type;
          this.valueIsCustomize = this.term.is_customized;
          this.valueIsForSale = this.term.for_sale;


        });
    },

    loadingRoundingRuleData: function() {
      servicehelpers.getRoundingRuleData().then(response => {
        this.roundingRuleDataList = response;
        
      });
    },


    submitSave: function() {
      
      this.tryingToSubmit = true;

      let term = {
        name: this.valueName,
        name_en: this.valueNameEn,
        period: this.valuePeroid,
        is_customized: this.valueIsCustomize,
        payment_period_type: this.valuePeroidType,
        rounding_rule_id: this.valueRoundingRule,
        for_sale: this.valueIsForSale,
      };

      console.log("AAAAA", JSON.stringify(term))

      if(this.isAdd) {
        paymenttermService.insert(term).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-term"
                });
              } 
            });

          }
        });
      } else {
        paymenttermService.update(this.$route.params.id, term).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-term"
                });
              } 
            });

          }
        });
      }

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.property.payment-term.text'),
        href: '/setting/property/payment/term',
      }, {
        text: $t('setting.property.payment-term.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.property.payment-term.new') : $t('setting.payment.payment-term.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.property.payment-term.text'),
        href: '/setting/property/payment/term',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.property.payment-term.new') : $t('setting.property.payment-term.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'setting.property.payment-term.name'"  />
                </div>
              </div>
              <div>
                <div class="col-md-12">
                  <Input 
                    :type="'text'"
                    :id="'name-en'"
                    v-model="valueNameEn"
                    :label="'setting.property.payment-term.name_en'"  />
                </div>
              </div>

              <div class="row">
               
                
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'peroid'"
                    v-model="valuePeroid"
                    :require="true"
                    :label="'setting.property.payment-term.period'"  />
                </div>
                <div class="col-lg-4">
                  <Select 
                    :text="'name'"
                    :id="'sex'"
                    v-model="valuePeroidType"
                    :list="this.paymentPeroidTypeDataList"
                    :label="'setting.property.payment-term.period_type'"  />
                </div>
                <div class="col-lg-4">
                  <Select 
                    :text="'name'"
                    :id="'sex'"
                    v-model="valueRoundingRule"
                    :list="this.roundingRuleDataList"
                    :label="'setting.property.payment-term.rounding_rule'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <b-form-group
                        class="mb-3"
                        :label="$t('setting.property.payment-term.is_customized')"
                        :label-for="id"
                    >
                      <div class="input-group" style="margin-left: 10px;"> 
                        <b-form-group class="input-group" id="type">
                          <div inline class="row gy-2 gx-3 align-items-end">
                          <b-form-radio
                            v-model="valueIsCustomize"
                            class="col-sm-auto"
                            value=0
                            plain
                            >No</b-form-radio>
                          <b-form-radio
                            v-model="valueIsCustomize"
                            class="col-sm-auto"
                            value=1
                            plain
                            >Yes</b-form-radio>
                          </div>
                        </b-form-group>
                        
                      </div>
                    </b-form-group>
                  </div>
                </div>
                 <div class="col-md-4">
                  <div class="form-group">
                    <b-form-group
                        class="mb-3"
                        :label="$t('setting.property.payment-term.for_sale')"
                        :label-for="id"
                    >
                      <div class="input-group" style="margin-left: 10px;"> 
                        <b-form-group class="input-group" id="type">
                          <div inline class="row gy-2 gx-3 align-items-end">
                          <b-form-radio
                            v-model="valueIsForSale"
                            class="col-sm-auto"
                            value=0
                            plain
                            >No</b-form-radio>
                          <b-form-radio
                            v-model="valueIsForSale"
                            class="col-sm-auto"
                            value=1
                            plain
                            >Yes</b-form-radio>
                          </div>
                        </b-form-group>
                        
                      </div>
                    </b-form-group>
                  </div>
                </div>

                 
               
              </div>
     
              

              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>